import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'statistics-card',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      padding: theme.spacing(2.875),
      border: `1px solid ${theme.palette.grey[100]}`,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    icon: {
      width: 24,
      height: 24,
      borderRadius: '50%',
      backgroundColor: theme.palette.grey[50],
    },
    label: {
      '& svg': {
        marginRight: theme.spacing(1),
      },
    },
    value: {
      marginTop: 'auto',
    },
    info: {
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        width: 'initial',
        height: 'initial',
      },
      '& span': {
        margin: theme.spacing(0, 0.5),
      },
    },
  }),
  options
);

export default useStyles;
